import * as React from "react";
import type { SVGProps } from "react";
const SvgNoteDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    fill="none"
    viewBox="0 0 12 13" {...props}
  >
    <path
      fill="#258695"
      fillRule="evenodd"
      d="M.667 1.333C.667.597 1.264 0 2 0h8c.737 0 1.334.597 1.334 1.333V12a.667.667 0 0 1-1.054.543l-1.946-1.39-1.946 1.39a.67.67 0 0 1-.775 0l-1.946-1.39-1.946 1.39A.667.667 0 0 1 .667 12zM3.334 3c0-.368.298-.667.666-.667h4a.667.667 0 0 1 0 1.334H4A.667.667 0 0 1 3.334 3M4 5a.667.667 0 0 0 0 1.333h4A.667.667 0 1 0 8 5zm0 2.667A.667.667 0 1 0 4 9h4a.667.667 0 0 0 0-1.333z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNoteDark;
